export interface BasicUser {
  id: string;
  displayName: string;
}

export const mockBasicUser: BasicUser = {
  id: '001',
  displayName: 'UNKNOWN_DISPLAY_NAME'
};
